import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import "./QRCodeSection.css";

const QRCodeSection = ({ qrString }) => {
  return (
    <div className="qrcode-section-container">
      <h3 className="qrcode-header">Scan QR to Pay</h3>
      <div className="qrcode-wrapper">
        {qrString ? (
          <QRCodeCanvas value={qrString} size={200} level="H" includeMargin={true} />
        ) : (
          <p>No QR code available</p>
        )}
      </div>
    </div>
  );
};

export default QRCodeSection;
